import { render, staticRenderFns } from "./OurWork.vue?vue&type=template&id=3d0ba1bc&scoped=true&"
import script from "./OurWork.vue?vue&type=script&lang=js&"
export * from "./OurWork.vue?vue&type=script&lang=js&"
import style0 from "./OurWork.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OurWork.vue?vue&type=style&index=1&id=3d0ba1bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ba1bc",
  null
  
)

export default component.exports